import React from "react";
import HasOptionList from "./HasOptionList";

export default class IconGroup extends HasOptionList {

    ref = React.createRef();

    classNameSelected() {
        return "selected";
    }

    classNameGroup() {
        return super.classNameGroup() + " iconGroup";
    }

    classNameItem() {
        return "";
    }

    render() {
        const props = this.props;
        const selectedOptionIndex = props.options.findIndex(o => this.getValue(o) == props.value);
        return (
            <div className={this.classNameGroup() + ' ' + this.getValue()}>
                {props.options.map((option, index) => (
                    <div key={index}
                         className={this.classNameItem() + ' ' + this.getValue(option) + ' ' + (index == selectedOptionIndex ? this.classNameSelected() : '')}
                         onClick={event => this.onChange(option,event)}>
                        {this.getLabel(option)}
                    </div>
                ))}
            </div>
        );
    }
}
